import React, { useState } from 'react';
import { Typography, Link } from '@mui/material';
import Fb from 'components/Fb';
import { copyright, domain } from 'config';
import useStyles from './styles';
import PrivacyPolicy from '../PrivacyPolicy';

function Copyright() {
  const classes = useStyles().classes;
  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);

  const handlePrivacyPolicyOpen = (event) => {
    event.preventDefault();
    setIsPrivacyPolicyOpen(true);
  };

  const handlePrivacyPolicyClose = () => {
    setIsPrivacyPolicyOpen(false);
  };

  return (
    <Fb justifyCenter pt={2} pb={2}>
      <Typography className={classes.copyright} variant="body2" color="textSecondary">
        {copyright.title}
        <Link color="inherit" href={domain}>
          {copyright.link}
        </Link>{' '}
        {new Date().getFullYear()}
        {' | '}
        <Link color="inherit" href="#" onClick={handlePrivacyPolicyOpen}>
          Privacy Policy
        </Link>
      </Typography>
      <PrivacyPolicy open={isPrivacyPolicyOpen} onClose={handlePrivacyPolicyClose} />
    </Fb>
  );
}

export default Copyright;
